// extracted by mini-css-extract-plugin
export default {"upload":"uploadButton_upload__reHXn","file-label":"uploadButton_file-label__LUjIk","icon":"uploadButton_icon__0uyTw"};